import { render, staticRenderFns } from "./SortRadios.vue?vue&type=template&id=a66ceada"
import script from "./SortRadios.vue?vue&type=script&lang=js"
export * from "./SortRadios.vue?vue&type=script&lang=js"
import style0 from "./SortRadios.vue?vue&type=style&index=0&id=a66ceada&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports